import { ifAuthenticated } from '@/router/before'
import { wikiURL } from '@/config/urls'

export const commonRouteNames = {
  HelpRoute: 'HelpRoute',
  ChangelogRoute: 'ChangelogRoute',
  ErrorRoute: 'ErrorRoute',
  MainPageRoute: 'MainPageRoute'
}
const rn = commonRouteNames

export const commonRouteURLs = {
  [rn.HelpRoute]: '/help-redirect',
  [rn.ChangelogRoute]: '/changelog',
  [rn.ErrorRoute]: '/error',
  [rn.MainPageRoute]: '/about'
}

export const commonPages = [
  {
    path: commonRouteURLs[rn.HelpRoute],
    name: rn.HelpRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'question-circle'],
        isDisplay: true
      },
      navbar: {
        group: 'Главная',
        displayName: 'Справка'
      }
    },
    beforeEnter: () => {
      window.location.href = wikiURL
    }
  },
  {
    path: commonRouteURLs[rn.ChangelogRoute],
    name: rn.ChangelogRoute,
    meta: {
      sidebar: {
        icon: ['far', 'lightbulb'],
        isDisplay: true
      },
      navbar: {
        group: 'Главная',
        displayName: 'Обновления системы'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ChangelogRoute" */ '@/views/common/ChangelogRoute.vue'
      )
  },
  {
    path: commonRouteURLs[rn.ErrorRoute],
    name: rn.ErrorRoute,
    meta: {
      sidebar: null,
      navbar: {
        group: 'Ошибка 404',
        displayName: 'Страница не найдена'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ErrorRoute" */ '@/views/common/ErrorRoute.vue'
      )
  },
  {
    path: commonRouteURLs[rn.MainPageRoute],
    name: rn.MainPageRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'info-circle'],
        isDisplay: true
      },
      navbar: {
        group: 'Главная',
        displayName: 'О проекте'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "MainPageRoute" */ '@/views/common/MainPageRoute.vue'
      )
  }
]
